import React from 'react'
import LottiePlayer from "lottie-react";
import certificate from '../../../assets/animationicons/certificates.json';

const NoCertificates = () => {
    return (
        <>
            <div className="nocertificates text-center" >
                <LottiePlayer
                    animationData={certificate}
                    style={{ height: 150, background:"transparent" }}
                    autoplay
                    loop
                />
                <h5 className='mt-3' style={{ background:"transparent" }}>No Certificates Found</h5>
            </div>
        </>
    )
}

export default NoCertificates
